export default __webpack_public_path__ + "static/N0273-75c543620368f967027409a61e76754f.png";